module.exports = __webpack_public_path__ + "static/media/trash-outline-red.adce8f84.svg";